import { Context, useContext } from 'react';
import { StepByStepContext, StepByStepContextValue } from './StepByStepProvider';

export const useStepByStep = <T = string>() =>
  useContext(StepByStepContext as unknown as Context<StepByStepContextValue<T>>);
